// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-mobile__wrapper[data-v-b290f7b6]{width:100%;color:#fff;padding:0 20px}.header-mobile__wrapper .header-mobile__gap-filler[data-v-b290f7b6]{position:absolute;top:-1px;background:#000;height:1px;width:100%;z-index:1;left:0}", ""]);
// Exports
module.exports = exports;
